import { type FC, useEffect, useState } from "react";
import intersection from "lodash/intersection";
import { RolePermissions, type SortingDirection, UsersGroupsContext } from "../../../../enums";
import Strings from "../../../../enums/strings";
import { type NotifyStepSettings, type GroupInfo, type PacksContextItem } from "../../../../interfaces";
import { type Filters } from "../../../../utils/queryUtils";
import { GroupListStep } from "../packIssueGroupLicenseModal/steps";
import { type RenderModalActionsType } from "components/assignmentModals/types";
import PackIssueLicenseToPeopleModal from "../PackIssueLicenseToPeopleModal";

export interface PackIssueLicenseToGroupModalProps {
  showModal: boolean;
  itemsPacks: PacksContextItem[];
  groupsAmount: number;
  isListLoading: boolean;
  isStepLoading: boolean;
  groups: GroupInfo[];
  loadPage: (
    skip: number,
    top: number,
    sortingColumnName: string,
    sortingDirection: SortingDirection,
    appliedFilter: Filters,
  ) => void;
  onSecondStep: (selectedIds: number[]) => Promise<void>;
  onConfirm: (notificationSettings?: NotifyStepSettings) => Promise<void>;
  onCancel: () => void;
  renderTrigger?: (closeModal: () => void) => React.ReactElement;
  setReloadListItems: (reloadItems: (enableSorting: boolean) => void) => void;
  setIssueLicensePackIds: (ids: number[]) => void;
}

export const PackIssueGroupLicenseModal: FC<PackIssueLicenseToGroupModalProps> = (
  props: PackIssueLicenseToGroupModalProps,
) => {
  const [selectedIds, setSelectedIds] = useState<number[]>([]);
  const { showModal, groupsAmount, isListLoading, groups, loadPage, setReloadListItems } = props;

  useEffect(() => {
    if (!showModal) {
      setSelectedIds([]);
    }
  }, [showModal]);

  const renderGroupsStep = (renderModalActions: RenderModalActionsType) => (
    <GroupListStep
      header={Strings.modalTitles.issueLicenseToGroups}
      renderModalActions={renderModalActions}
      loadPage={loadPage}
      isLoading={isListLoading}
      groups={groups}
      groupsAmount={groupsAmount}
      onSelectedGroupsChanged={setSelectedIds}
      selectedGroupIds={selectedIds}
      hasPermissionPredicate={(userPermissions) =>
        intersection(userPermissions, [RolePermissions.GroupsView]).length > 0
      }
      setReloadListItems={setReloadListItems}
    />
  );

  return (
    <PackIssueLicenseToPeopleModal
      className={"pack-group-license-modal"}
      selectedIds={selectedIds}
      renderFirstStep={renderGroupsStep}
      usersGroupsContext={UsersGroupsContext.Groups}
      licenseConfirmationData={{
        groupIds: selectedIds,
        userIds: [],
      }}
      {...props}
    />
  );
};

export default PackIssueGroupLicenseModal;
